module.exports = __webpack_public_path__ + "static/img/14.ce1ce22.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/eng/14.png
// module id = kvOt
// module chunks = 0